import { searchFormStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm";
import { css } from "styled-components";

searchFormStyles.wrapper ={
    css: css`
            margin-bottom: 30px;
        `,
}